import pageMeta from 'btm-pageMeta/pageMeta'; //eslint-disable-line import/no-unresolved, import/extensions
import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies


// Some browsers (mainly IE) does not have this property, so we need to build it manually...
if (!window.location.origin) {
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`; //eslint-disable-line max-len
}

const sectionId = pageMeta.section;

function getOneIDLangPref() {
    const lang = pageMeta.locale.split('_')[0];

    if (lang && lang === 'es') {
        return 'es-LA';
    } else {
        return 'en-US';
    }
}

const getDisneyIdConfig = function () {
    const responderUrl = window.location.hostname.indexOf('espnqa.com') > -1 ?
        window.server_path.responder_espnqa : window.server_path.responder;

    const disneyIdConfig = {
        clientId: 'ESPN-ONESITE.WEB',
        responderPage: responderUrl,
        cssOverride: `${window.server_path.espnstatic}/disneyid/styles/oneid-web.min.css`,
        langPref: getOneIDLangPref(),
        optionalConfigs: {
            reporting: {
                source: 'DTC',
                context: 'direct'
            }
        }
    };

    if (sectionId === 'paywall') {
        disneyIdConfig.cssOverride = `${window.server_path.espnstatic}/disneyid/styles/oneid-paywall.min.css`;
    }

    return disneyIdConfig;
};

const disneyIdConfig = getDisneyIdConfig();
let disneyIdService;
let initPromise;
let forceTokenRefresh;
let handleBreachErrors;

if (window.DisneyID) {
    if (!disneyIdService) {
        disneyIdService = window.DisneyID.get(disneyIdConfig);
    }

    initPromise = disneyIdService.init();

    // Auto-refresh BAMTECH token whenever OneID token is refreshed
    disneyIdService.on('refresh', (token) => {
        return user.external.logout().then(() => {
            return user.external.login(token.id_token, token.swid);
        }).catch(handleBreachErrors);
    });

    // Create a self-contained counter that can be called by name to increment it.
    const refreshAttemptCounter = (function () {
        let count = 0;
        return function () {
            return count++;
        };
    }());

    forceTokenRefresh = function () {
        const tries = refreshAttemptCounter();
        console.log(`Attempting to refresh OneId token, try ${tries}`);
        if (tries > 2) {
            console.warn('Refresh OneId token attempt limit hit.');
            return disneyIdService.logout().then(() => {
                return user.external.logout();
            });
        }
        return disneyIdService.forceTokenRefresh().fail(() => {
            return disneyIdService.logout().then(() => {
                return user.external.logout();
            });
        });
    };

    handleBreachErrors = function (error) {
        console.error(error);
        if (error && error.reasons && error.reasons.length > 0 && error.reasons[0].code === 'invalid_grant') {
            return forceTokenRefresh().fail(() => {
                return disneyIdService.logout()
                    .then(() => {
                        return user.external.logout();
                    });
            });
        }
        return Promise.resolve();
    };
}

const exportedService = {
    init() {
        return initPromise || Promise.reject(new Error('This page does not include Disney OneID'));
    },

    getOneIDLangPref,
    getDisneyIdConfig,
    disneyIdService,
    forceTokenRefresh,
    handleBreachErrors
};

window.disneyOneIdWrapper = exportedService;

export default exportedService;
